import Context from "../../context/Context";
import FieldNames from "../../aiim/datasets/FieldNames";
import OfficePlan from "./OfficePlan";
//import Reader from "./Reader";
import * as aiimUtil from "../../aiim/util/aiimUtil";
import * as queryUtil from "./queryUtil";
import * as selectionUtil from "../../aiim/util/selectionUtil";
import * as sourceUtil from "./sourceUtil";

/*
  Transactions

    assignPeopleToArea
    assignPeopleToUnit
    unassignPeople

    assignUnitsToArea
    unassignUnits

    addArea
    deleteArea
    renameArea
    unassignArea

 */

//const TIMEOUT = (60000 * 30);

const unitBasedFieldsForPeople = [
  "site_id","site_name",
  "facility_id","facility_name",
  "level_id","level_name","level_number","vertical_order",
  "unit_id","unit_name",
  "section_id","section_name",
  "access_type","use_type",
  "capacity","utilization",
  "area_gross","area_net","area_um",
  "elevation_absolute","elevation_relative",
  "height_absolute","height_relative",
  "name_long","name_subtitle","description"
];
// "image_url","orig_fid",
// "contact_email","contact_extension","contact_name","contact_phone","contact_url",
// "source_name","source_path","source_type","source_method",

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

// export function addArea(areaType,areaId,areaName) {
//   const task = {
//     areaType: areaType,
//     areaId: areaId,
//     areaName: areaName,
//     addArea: true
//   };
//   return updateArea(task);
// }

export function applyGdbVersion(layer,editOptions) {
  if (layer && layer.gdbVersion && editOptions) {
    editOptions.gdbVersion = layer.gdbVersion;
  }
}

// export function assignPeopleToArea(peopleFeatureItems,areaItem,areaType) {
//   const task = {
//     peopleFeatureItems: peopleFeatureItems,
//     assignPeopleToArea: {
//       areaItem: areaItem,
//       areaType: areaType
//     }
//   };
//   return updatePeopleAssignments(task);
// }
//
// export function assignPeopleToUnit(peopleFeatureItems,unitFeatureItem) {
//   const task = {
//     peopleFeatureItems: peopleFeatureItems,
//     assignPeopleToUnit: {
//       unitFeatureItem: unitFeatureItem
//     }
//   };
//   return updatePeopleAssignments(task);
// }
//
// export function assignUnitsToArea(unitFeatureItems,areaItem,areaType) {
//   const task = {
//     unitFeatureItems: unitFeatureItems,
//     assignUnitsToArea: {
//       areaItem: areaItem,
//       areaType: areaType
//     }
//   };
//   return updateUnitAssignments(task);
// }
//
// export function deleteArea(areaItem,areaType) {
//   const task = {
//     areaItem: areaItem,
//     areaType: areaType,
//     unassignArea: true,
//     deleteArea: true
//   };
//   return updateArea(task);
// }
//
// export function renameArea(areaItem,areaType,areaName) {
//   const task = {
//     areaItem: areaItem,
//     areaType: areaType,
//     areaName: areaName,
//     renameArea: true
//   };
//   return updateArea(task);
// }
//
// export function unassignArea(areaItem,areaType) {
//   const task = {
//     areaItem: areaItem,
//     areaType: areaType,
//     unassignArea: true
//   };
//   return updateArea(task);
// }
//
// export function unassignPeople(peopleFeatureItems) {
//   const task = {
//     peopleFeatureItems: peopleFeatureItems,
//     unassignPeople: true
//   };
//   return updatePeopleAssignments(task);
// }
//
// export function unassignUnits(unitFeatureItems) {
//   const task = {
//     unitFeatureItems: unitFeatureItems,
//     unassignUnits: true
//   };
//   return updateUnitAssignments(task);
// }

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

export function addAttributeEdit(fields,attributes,name,value) {
  const f = aiimUtil.findField(fields,name);
  if (f) attributes[f.name] = value;
}

export function getPeopleSource() {
  return sourceUtil.getPeopleSource();
}

export function getUnitsSource() {
  return sourceUtil.getUnitsSource();
}

export function getPersonAssignmentName(personFeatureItem) {
  //const msg = "Inconsistant space assignment type for person:";
  const attributes = personFeatureItem.feature.attributes;
  //const asnType = aiimUtil.getAttributeValue(attributes,FieldNames.PEOPLE_SPACE_ASSIGNMENT_TYPE);
  const unitId = aiimUtil.getAttributeValue(attributes,FieldNames.UNIT_ID);
  const areaId = aiimUtil.getAttributeValue(attributes,FieldNames.PEOPLE_AREA_ID);
  const hasUnitId = (typeof unitId === "string" && unitId.length > 0);
  const hasAreaId = (typeof areaId === "string" && areaId.length > 0);
  if (hasUnitId) {
    // if (hasAreaId || (asnType !== OfficePlan.SpaceAssignmentTypes.office)) {
    //   //console.warn(msg,personFeatureItem);
    // }
    return aiimUtil.getAttributeValue(attributes,FieldNames.UNIT_NAME);
  } else {
    if (hasAreaId) {
      // if (asnType !== OfficePlan.SpaceAssignmentTypes.hotdesk &&
      //     asnType !== OfficePlan.SpaceAssignmentTypes.hotel) {
      //   console.warn(msg,personFeatureItem);
      // }
      // return OfficePlan.getActive().getAreaName(areaId,asnType);
      return OfficePlan.getActive().getAreaName(areaId);
    } else {
      // if (asnType === OfficePlan.SpaceAssignmentTypes.none) {
      //   return Context.instance.i18n.spaceplanner.people.noAssignment;
      // }
      // if (asnType !== OfficePlan.SpaceAssignmentTypes.none) {
      //   //console.warn(msg,personFeatureItem);
      // }
      return Context.instance.i18n.spaceplanner.people.noAssignment;
    }
  }
}

export function getUnitAssignmentType(unitFeatureItem) {
  const attributes = unitFeatureItem.feature.attributes;
  return aiimUtil.getAttributeValue(attributes,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);
}

export function getUnitAssignmentName(unitFeatureItem) {
  // TODO validate the FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE
  const msg = "Inconsistant space assignment type for unit:";
  const attributes = unitFeatureItem.feature.attributes;
  const asnType = aiimUtil.getAttributeValue(attributes,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);
  const areaId = aiimUtil.getAttributeValue(attributes,FieldNames.UNITS_AREA_ID);
  const hasAreaId = (typeof areaId === "string" && areaId.length > 0);
  //console.log("asnType",asnType,"hasAreaId",hasAreaId,unitFeatureItem.feature.attributes);
  if (hasAreaId) {
    if (asnType !== OfficePlan.SpaceAssignmentTypes.hotdesk &&
        asnType !== OfficePlan.SpaceAssignmentTypes.hotel) {
      console.warn(msg,unitFeatureItem);
    }
    return OfficePlan.getActive().getAreaName(areaId,asnType);
  } else if (asnType === OfficePlan.SpaceAssignmentTypes.office) {
    // validate that people are actually assigned?
    return Context.instance.i18n.spaceplanner.units.occupied;
  } else if (asnType === OfficePlan.SpaceAssignmentTypes.none) {
    return Context.instance.i18n.spaceplanner.units.unoccupied;
  } else if (asnType === OfficePlan.SpaceAssignmentTypes.notAssignable) {
    return Context.instance.i18n.spaceplanner.units.notAssignable;
  }
}

export function isPersonAssignedToUnit(featureItem) {
  const unitId = aiimUtil.getAttributeValue(featureItem.feature.attributes,FieldNames.UNIT_ID);
  const hasUnitId = (typeof unitId === "string" && unitId.length > 0);
  return hasUnitId;
}

export function isPersonUnassigned(featureItem) {
  const unitId = aiimUtil.getAttributeValue(featureItem.feature.attributes,FieldNames.UNIT_ID);
  const areaId = aiimUtil.getAttributeValue(featureItem.feature.attributes,FieldNames.PEOPLE_AREA_ID);
  const hasUnitId = (typeof unitId === "string" && unitId.length > 0);
  const hasAreaId = (typeof areaId === "string" && areaId.length > 0);
  return !(hasUnitId || hasAreaId);
}

export function isUnitUnassigned(featureItem) {
  const attributes = featureItem.feature.attributes;
  const asnType = aiimUtil.getAttributeValue(attributes,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);
  const areaId = aiimUtil.getAttributeValue(attributes,FieldNames.UNITS_AREA_ID);
  const hasAreaId = (typeof areaId === "string" && areaId.length > 0);
  return !(hasAreaId || asnType !== OfficePlan.SpaceAssignmentTypes.none);
}

export function getPeople(unitFeatureItems) {
  let where = "";
  const unitsLayer = sourceUtil.getUnitsSource().layer2D;
  const peopleLayer = sourceUtil.getPeopleSource().layer2D;
  const fldA = aiimUtil.findField(unitsLayer.fields,FieldNames.UNIT_ID);
  const fldB = aiimUtil.findField(peopleLayer.fields,FieldNames.PEOPLE_UNIT_ID);
  const nameFld = aiimUtil.findField(peopleLayer.fields,FieldNames.PEOPLE_FULLNAME);

  const values = [];
  unitFeatureItems.forEach((featureItem,i) => {
    let v = aiimUtil.getAttributeValue(featureItem.attributes,fldA.name);
    v = "'" + selectionUtil.escSqlQuote(v) + "'";
    values.push(v);
  });
  if (values.length > 0) where = fldB.name + " IN (" + values.join(",") + ")";
  else return Promise.resolve({features: []});

  if (where.length > 0) {
    const options = {
      source: getPeopleSource(),
      where: where,
      orderByFields: [nameFld.name],
      outFields: ["*"],
      returnGeometry:true,
      returnZ:true
    }
    return queryUtil.queryFeatures(options).then(result => {
      if (result && result.features) {
        return result;
      }else{
        return ({features:[]});
      }
    });
  }
}

export function makeWhereForPeopleAssignedToArea(areaItem,areaType) {
  const areaId = aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_ID);
  const source = getPeopleSource();
  const layer = source.layer2D;
  const areaIdField = aiimUtil.findField(layer.fields,FieldNames.PEOPLE_AREA_ID);
  const v = selectionUtil.escSqlQuote(areaId);
  const where = "("+areaIdField.name+" = '"+v+"')";
  return where;
  // const asnTypeField = aiimUtil.findField(layer.fields,FieldNames.PEOPLE_SPACE_ASSIGNMENT_TYPE);
  // let v1 = selectionUtil.escSqlQuote(areaId);
  // v1 = "("+areaIdField.name+" = '"+v1+"')";
  // let v2 = selectionUtil.escSqlQuote(areaType);
  // v2 = "("+asnTypeField.name+" = '"+v2+"')";
  // const where = v1 + " AND " + v2;
  // return where;
}

export function makeWhereForUnitsAssignedToArea(areaItem,areaType) {
  const areaId = aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_ID);
  const source = getUnitsSource();
  const layer = source.layer2D;
  const areaIdField = aiimUtil.findField(layer.fields,FieldNames.UNITS_AREA_ID);
  const asnTypeField = aiimUtil.findField(layer.fields,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);
  let v1 = selectionUtil.escSqlQuote(areaId);
  v1 = "("+areaIdField.name+" = '"+v1+"')";
  let v2 = selectionUtil.escSqlQuote(areaType);
  v2 = "("+asnTypeField.name+" = '"+v2+"')";
  const where = v1 + " AND " + v2;
  return where;
}

export function queryPeopleAssignedToArea(areaItem,areaType) {
  const source = getPeopleSource();
  const layer = source.layer2D;
  const orderByField = aiimUtil.findField(layer.fields,FieldNames.PEOPLE_FULLNAME);
  const where = makeWhereForPeopleAssignedToArea(areaItem,areaType);
  const options = {
    source: source,
    where: where,
    orderByFields: [orderByField.name]
  };
  return queryUtil.queryFeatures(options).then(result => {
    if (result && result.features) {
      const resultInfo = queryUtil.makeResultInfo(source,result);
      return resultInfo.featureItems;
    } else {
      return [];
    }
  });
}

export function queryPeopleAssignedToUnit(unitFeatureItem) {
  const unitIdField = FieldNames.UNIT_ID;
  const unitId = aiimUtil.getAttributeValue(unitFeatureItem.feature.attributes,unitIdField);
  const source = getPeopleSource();
  const v = selectionUtil.escSqlQuote(unitId);
  const where = "("+unitIdField+" = '"+v+"')";
  const options = {
    source: source,
    where: where,
    orderByFields: [FieldNames.PEOPLE_FULLNAME],
    returnGeometry: true
  }
  return queryUtil.queryFeatures(options).then(result => {
    if (result && result.features) {
      const resultInfo = queryUtil.makeResultInfo(source,result);
      return resultInfo.featureItems;
    } else {
      return [];
    }
  });
}

export function queryPeopleNamesAssignedToUnits(unitFeatureItems) {
  let where = "";
  const unitsLayer = sourceUtil.getUnitsSource().layer2D;
  const peopleLayer = sourceUtil.getPeopleSource().layer2D;
  const fldA = aiimUtil.findField(unitsLayer.fields,FieldNames.UNIT_ID);
  const fldB = aiimUtil.findField(peopleLayer.fields,FieldNames.PEOPLE_UNIT_ID);
  const nameFld = aiimUtil.findField(peopleLayer.fields,FieldNames.PEOPLE_FULLNAME);

  const values = [];
  unitFeatureItems.forEach((featureItem,i) => {
    let v = aiimUtil.getAttributeValue(featureItem.feature.attributes,fldA.name);
    v = "'" + selectionUtil.escSqlQuote(v) + "'";
    values.push(v);
  });
  if (values.length > 0) where = fldB.name + " IN (" + values.join(",") + ")";

  // unitFeatureItems.forEach((featureItem,i) => {
  //   let v = aiimUtil.getAttributeValue(featureItem.feature.attributes,fldA.name);
  //   v = "'" + selectionUtil.escSqlQuote(v) + "'";
  //   let part = "("+fldB.name+" = "+v+")";
  //   if (where.length > 0) where += " OR ";
  //   where += part;
  // });

  if (where.length > 0) {
    const options = {
      source: getPeopleSource(),
      where: where,
      orderByFields: [nameFld.name],
      outFields: [nameFld.name]
    }
    return queryUtil.queryFeatures(options).then(result => {
      const names = [];
      if (result && result.features) {
        result.features.forEach(f => {
          let v = aiimUtil.getAttributeValue(f.attributes,nameFld.name);
          names.push(v);
        });
      }
      return {
        names: names,
        exceededTransferLimit: result.exceededTransferLimit
      }
    });
  }
}

export function queryUnitsAssignedToArea(areaItem,areaType) {
  const source = getUnitsSource();
  const layer = source.layer2D;
  const orderByField = aiimUtil.findField(layer.fields,FieldNames.NAME);
  const where = makeWhereForUnitsAssignedToArea(areaItem,areaType);
  const options = {
    source: source,
    where: where,
    orderByFields: [orderByField.name]
  };
  return queryUtil.queryFeatures(options).then(result => {
    if (result && result.features) {
      const resultInfo = queryUtil.makeResultInfo(source,result);
      return resultInfo.featureItems;
    } else {
      return [];
    }
  });
}
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

export function appendPersonUnassignment(task,peopleFields,peopleUpdate) {
  if (task.isVersioned === undefined) {
    const p = Context.instance.spaceplanner.planner;
    if (p && p.project) {
      task.isVersioned = !!p.project.isVersioned;
    }
  }
  addAttributeEdit(peopleFields,peopleUpdate.attributes,
    FieldNames.PEOPLE_AREA_ID,null);
  // addAttributeEdit(peopleFields,peopleUpdate.attributes,
  //   FieldNames.PEOPLE_SPACE_ASSIGNMENT_TYPE,
  //   OfficePlan.SpaceAssignmentTypes.none);
  unitBasedFieldsForPeople.forEach(f => {
    addAttributeEdit(peopleFields,peopleUpdate.attributes,f,null);
  });
  const pt = new Context.instance.lib.esri.Point({wkid: 4326});
  pt.x = pt.y = null;
  if (task.isVersioned) {
    // TODO?
    pt.x = pt.y = 0; pt.z = 0;
  }
  peopleUpdate.geometry = pt;
}

// function appendUnitUnassignment(task,unitFields,unitUpdate) {
//   addAttributeEdit(unitFields,unitUpdate.attributes,
//     FieldNames.UNITS_AREA_ID,null);
//   addAttributeEdit(unitFields,unitUpdate.attributes,
//     FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE,
//     OfficePlan.SpaceAssignmentTypes.none);
//   addAttributeEdit(unitFields,unitUpdate.attributes,
//     FieldNames.UTILIZATION, 0)
// }

// function calculateUtilization(unitIds){
//   let returnObj={
//     unitObjectIds:[],
//     utilizationByObjectId:{},
//     utilizationByUnitId: {},
//   };
//   if (!unitIds || unitIds.length === 0) return Promise.resolve(returnObj);
//   const promise = new Promise((resolve, reject)=>{
//     const peopleSource = getPeopleSource();
//     const peopleLayer = peopleSource.layer2D;
//     const unitIdField = aiimUtil.findField(peopleLayer.fields,FieldNames.UNIT_ID);
//     const lib = Context.instance.lib;
//     const values = [];
//
//     let unitObjectIdDict = {};
//     unitIds.forEach(unitId => {
//       let v = "'" + selectionUtil.escSqlQuote(unitId) + "'";
//       values.push(v);
//     });
//
//     const featureLayerUnits= getUnitsSource().layer2D;
//     const ObjectID=featureLayerUnits.objectIdField;
//     var query = featureLayerUnits.createQuery();
//     query.outFields = [unitIdField.name, ObjectID];
//     query.where = unitIdField.name + " IN (" + values.join(",") + ")";
//
//     featureLayerUnits.queryFeatures(query)
//     .then(function(response){
//       for (let i = 0; i < response.features.length; i++) {
//         let objectId = response.features[i].attributes[ObjectID];
//         returnObj.unitObjectIds.push(objectId);
//         unitObjectIdDict[response.features[i].attributes[unitIdField.name]] = objectId;
//       }
//     }).then(()=>{
//         var queryPeopleLayer = peopleLayer.createQuery();
//         let where = unitIdField.name + " IN (" + values.join(",") + ")";
//         const staticDefine = new lib.esri.StatisticDefinition({
//           statisticType: "count",
//           onStatisticField: unitIdField.name,
//           outStatisticFieldName: "Utilization"
//         })
//         queryPeopleLayer.where = where;
//         queryPeopleLayer.outStatistics = [staticDefine];
//         queryPeopleLayer.groupByFieldsForStatistics = [unitIdField.name];
//         queryPeopleLayer.outFields = ["*"];
//
//         return (
//           peopleLayer.queryFeatures(queryPeopleLayer).then(function(results){
//             for(let i=0;i<results.features.length;i++){
//               let unitId= results.features[i].attributes[unitIdField.name];
//               let oid = unitObjectIdDict[unitId];
//               const utilization = results.features[0].attributes.Utilization;
//               returnObj.utilizationByObjectId[oid] = utilization;
//               returnObj.utilizationByUnitId[unitId] = utilization;
//             }
//           })
//         )
//     }).then(()=>{
//       resolve(returnObj);
//       return(returnObj);
//     }).catch(error=>{
//       reject(error);
//     })
//   })
//   return promise;
// }

// function arePeopleStillAssigned(task,unitIds,primaryUnitId) {
//   if (!unitIds || unitIds.length === 0) return Promise.resolve();
//   const promise = new Promise((resolve,reject) => {
//     const stillAssigned = [];
//     const lib = Context.instance.lib;
//     const source = getPeopleSource();
//     const layer = source.layer2D;
//     const unitIdField = aiimUtil.findField(layer.fields,FieldNames.UNIT_ID);
//
//     const values = [];
//     unitIds.forEach(unitId => {
//       let v = "'" + selectionUtil.escSqlQuote(unitId) + "'";
//       values.push(v);
//     });
//     let where = unitIdField.name + " IN (" + values.join(",") + ")";
//     // let where = "";
//     // unitIds.forEach(unitId => {
//     //   let v = "'" + selectionUtil.escSqlQuote(unitId) + "'";
//     //   let part = "("+unitIdField.name+" = "+v+")";
//     //   if (where.length > 0) where += " OR ";
//     //   where += part;
//     // });
//     //console.log("arePeopleStillAssigned====================================",where)
//     const url = Context.checkMixedContent(source.url);
//     const queryTask = new lib.esri.QueryTask({url: url});
//     const query = new lib.esri.Query();
//     query.where = where;
//     query.outFields = [unitIdField.name];
//     query.returnGeometry = false;
//     query.returnDistinctValues = true;
//     queryUtil.applyGdbVersion(source,query);
//     queryTask.execute(query).then(result => {
//       console.log("stillAssignedResult",result)
//       if (result && result.features) {
//         result.features.forEach(feature => {
//           let id = aiimUtil.getAttributeValue(feature.attributes,unitIdField.name);
//           if (typeof id === "string" && id.length > 0) {
//             if (stillAssigned.indexOf(id) === -1) {
//               stillAssigned.push(id);
//             }
//           }
//         });
//       }
//       task.stillAssignedUnitIds = stillAssigned;
//       const unitIdsToFix = [];
//       unitIds.forEach(unitId => {
//         if (unitId === primaryUnitId || stillAssigned.indexOf(unitId) === -1) {
//           unitIdsToFix.push(unitId);
//         }
//       });
//       task.unitIdsToFix = unitIdsToFix;
//       resolve();
//     }).catch(ex => {
//       reject(ex);
//     });
//   });
//   return promise;
// }

export function checkUpdateResult(result) {
  const checked = {};
  const updateResults = result && result.updateFeatureResults;
  if (Array.isArray(updateResults)) {
    updateResults.some(ur => {
      if (ur.error) {
        ur.error.submessage = ur.error.message;
        checked.error = ur.error;
        return true;
      }
      return false;
    });
  }
  return checked;
}

// function clonePersonFeature(feature,geometryOption) {
//   const cloned = {};
//   cloned.attributes = Object.assign({},feature.attributes);
//   if (feature.geometry) {
//     if (typeof feature.geometry.toJSON === "function") {
//       cloned.geometry = feature.geometry.toJSON()
//     } else {
//       cloned.geometry = feature.geometry;
//     }
//   } else if (geometryOption === "ensure-geometry") {
//     throw new Error("Person feature has no geometry");
//   }
//   console.log("cloned",cloned);
//   return cloned;
// }
//
// function cloneUnitFeature(feature,geometryOption) {
//   const cloned = {};
//   cloned.attributes = Object.assign({},feature.attributes);
//   if (feature.geometry && (geometryOption !== "no-geometry")) {
//     if (typeof feature.geometry.toJSON === "function") {
//       cloned.geometry = feature.geometry.toJSON()
//     } else {
//       cloned.geometry = feature.geometry;
//     }
//   }
//   console.log("cloned",cloned);
//   return cloned;
// }

// function fetchRelatedPeople(task,unitIds) {
//   let fetchResult = {
//     objectIds: [],
//     features: null
//   };
//   if (!unitIds || unitIds.length === 0) return Promise.resolve(fetchResult);
//   const promise = new Promise((resolve,reject) => {
//     const lib = Context.instance.lib;
//     const source = getPeopleSource();
//     const layer = source.layer2D;
//     const fields = layer.fields;
//     const objectIdField = layer.objectIdField;
//     const unitIdField = aiimUtil.findField(fields,FieldNames.PEOPLE_UNIT_ID).name;
//
//     const values = [];
//     unitIds.forEach(unitId => {
//       let v = "'" + selectionUtil.escSqlQuote(unitId) + "'";
//       values.push(v);
//     });
//     let where = unitIdField + " IN (" + values.join(",") + ")";
//     const url = Context.checkMixedContent(source.url);
//     const queryTask = new lib.esri.QueryTask({url: url});
//     const query = new lib.esri.Query();
//     query.where = where;
//     query.outFields = ["*"];
//     query.returnGeometry = true;
//     query.returnZ = true;
//     queryUtil.applyGdbVersion(source,query);
//     queryTask.execute(query).then(result => {
//       console.log("fetchRelatedPeople",result)
//       if (result && result.features) {
//         fetchResult.features = result.features;
//         result.features.forEach(feature => {
//           let oid = aiimUtil.getAttributeValue(feature.attributes,objectIdField);
//           fetchResult.objectIds.push(oid);
//         });
//       };
//       resolve(fetchResult);
//     }).catch(ex => {
//       reject(ex);
//     });
//   });
//   return promise;
// }
//
// function fetchRelatedUnits(task,unitIds) {
//   let fetchResult = {
//     objectIds: [],
//     unitIdsByObjectId: {},
//     features: null,
//     featuresByObjectId: {}
//   }
//   if (!unitIds || unitIds.length === 0) return Promise.resolve(fetchResult);
//   const promise = new Promise((resolve,reject) => {
//     const lib = Context.instance.lib;
//     const source = getUnitsSource();
//     const layer = source.layer2D;
//
//     const fields = layer.fields;
//     const objectIdField = layer.objectIdField;
//     const unitIdField = aiimUtil.findField(fields,FieldNames.UNIT_ID).name;
//     const areaIdField = aiimUtil.findField(fields,FieldNames.UNITS_AREA_ID).name;
//     const asnTypeField = aiimUtil.findField(fields,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE).name;
//     const utilField = aiimUtil.findField(fields,FieldNames.UTILIZATION).name;
//
//     const values = [];
//     unitIds.forEach(unitId => {
//       let v = "'" + selectionUtil.escSqlQuote(unitId) + "'";
//       values.push(v);
//     });
//     let where = unitIdField + " IN (" + values.join(",") + ")";
//     const url = Context.checkMixedContent(source.url);
//     const queryTask = new lib.esri.QueryTask({url: url});
//     const query = new lib.esri.Query();
//     query.where = where;
//     query.outFields = [objectIdField,unitIdField,areaIdField,asnTypeField,utilField];
//     query.returnGeometry = false;
//     queryUtil.applyGdbVersion(source,query);
//     queryTask.execute(query).then(result => {
//       console.log("fetchRelatedUnits",result)
//       if (result && result.features) {
//         fetchResult.features = result.features;
//         result.features.forEach(feature => {
//           let oid = aiimUtil.getAttributeValue(feature.attributes,objectIdField);
//           let unitId = aiimUtil.getAttributeValue(feature.attributes,unitIdField);
//           fetchResult.objectIds.push(oid);
//           fetchResult.featuresByObjectId[oid] = feature;
//           fetchResult.unitIdsByObjectId[oid] = unitId;
//         });
//       };
//       resolve(fetchResult);
//     }).catch(ex => {
//       reject(ex);
//     });
//   });
//   return promise;
// }
//
// function makeApplyEditsRequestInfo(edits,opts) {
//   const unitsLayer = getUnitsSource().layer2D;
//   const serviceUrl = unitsLayer.url;
//   const editOptions = {
//     edits: JSON.stringify(edits),
//     rollbackOnFailure: true,
//     f: "json"
//   };
//   if (opts && opts.useGlobalIds) editOptions.useGlobalIds = true;
//   applyGdbVersion(unitsLayer,editOptions);
//   const transaction = {
//     requestUrl: serviceUrl+"/applyEdits",
//     requestOptions: {
//       query: editOptions,
//       method: "post",
//       responseType: "json",
//       timeout: TIMEOUT
//     }
//   };
//   return transaction;
// }

// function makeTransactionInfo() {
//   const transactionInfo = {
//     peopleEdits: null,
//     unitEdits: null,
//     areasTableEdits: null,
//     edits: [],
//     useGlobalIds: true,
//     undo: {
//       peopleEdits: null,
//       unitEdits: null,
//       areasTableEdits: null,
//       edits: [],
//       useGlobalIds: true
//     }
//   };
//   return transactionInfo;
// }

// function makeUndoTransaction(transactionInfo) {
//   const edits = transactionInfo.edits;
//   const undoEdits = transactionInfo.undo.edits;
//   const undoManager = OfficePlan.getActive().undoManager;
//   const undoTransaction = undoManager.makeTransaction({
//     hadPeopleEdits: !!transactionInfo.peopleEdits,
//     hadUnitEdits: !!transactionInfo.unitEdits,
//     hadAreasTableEdits: !!transactionInfo.areasTableEdits,
//     requestInfo: makeApplyEditsRequestInfo(undoEdits,transactionInfo.undo)
//   });
//   undoTransaction.redoTransaction = undoManager.makeTransaction({
//     hadPeopleEdits: !!transactionInfo.peopleEdits,
//     hadUnitEdits: !!transactionInfo.unitEdits,
//     hadAreasTableEdits: !!transactionInfo.areasTableEdits,
//     requestInfo: makeApplyEditsRequestInfo(edits,transactionInfo)
//   });
//   console.log("undoTransaction",undoTransaction);
//   return undoTransaction;
// }

// function makeUnassignPeopleUpdates(task,keys,keyField) {
//   const fields = getPeopleSource().layer2D.fields;
//   const updates = [];
//   if (Array.isArray(keys)) {
//     keys.forEach(key => {
//       const update = {attributes: {}};
//       update.attributes[keyField] = key;
//       appendPersonUnassignment(task,fields,update);
//       updates.push(update);
//     });
//   }
//   return updates;
// }

// function makeUnassignUnitEdits(task,unitObjectIds) {
//   let edits;
//   const source = getUnitsSource();
//   const layer = source.layer2D;
//   const fields = layer.fields;
//   const updates = [];
//   if (Array.isArray(unitObjectIds)) {
//     unitObjectIds.forEach(oid => {
//       const update = {attributes: {}};
//       update.attributes[layer.objectIdField] = oid;
//       appendUnitUnassignment(task,fields,update);
//       updates.push(update);
//     });
//   }
//   if (updates.length > 0) edits = {updates: updates};
//   return edits;
// }

// function queryGlobalIndex(source,unitOrAreaIds,areaType) {
//   if (!unitOrAreaIds || unitOrAreaIds.length === 0) return Promise.resolve([]);
//   const layer = source.layer2D;
//   let idField;
//   if (!areaType) {
//     idField = aiimUtil.findField(layer.fields,FieldNames.UNIT_ID);
//   } else {
//     if (source.isAiimPeople()) {
//       idField = aiimUtil.findField(layer.fields,FieldNames.PEOPLE_AREA_ID);
//     } else if (source.isAiimUnits()) {
//       idField = aiimUtil.findField(layer.fields,FieldNames.UNITS_AREA_ID);
//     }
//   }
//   const values = [];
//   unitOrAreaIds.forEach(id => {
//     let v = "'" + selectionUtil.escSqlQuote(id) + "'";
//     values.push(v);
//   });
//   let where = idField.name + " IN (" + values.join(",") + ")";
//
//   let opts = {
//     source: source,
//     where: where,
//     globalIdField: source.layer2D.globalIdField,
//     globalIdIndex: {},
//     //toUpper: true
//   };
//   const reader = new Reader();
//   return reader.readLayerGlobalIdIndex(opts).then(result => {
//     return opts;
//   });
// }

// function queryObjectIds(source,unitOrAreaIds,areaType) {
//   //console.log(unitIdsToFix)
//   if (!unitOrAreaIds || unitOrAreaIds.length === 0) return Promise.resolve([]);
//   const lib = Context.instance.lib;
//   const layer = source.layer2D;
//   let idField;
//   if (!areaType) {
//     idField = aiimUtil.findField(layer.fields,FieldNames.UNIT_ID);
//   } else {
//     if (source.isAiimPeople()) {
//       idField = aiimUtil.findField(layer.fields,FieldNames.PEOPLE_AREA_ID);
//     } else if (source.isAiimUnits()) {
//       idField = aiimUtil.findField(layer.fields,FieldNames.UNITS_AREA_ID);
//     }
//   }
//   const values = [];
//   unitOrAreaIds.forEach(id => {
//     let v = "'" + selectionUtil.escSqlQuote(id) + "'";
//     values.push(v);
//   });
//   let where = idField.name + " IN (" + values.join(",") + ")";
//   // unitOrAreaIds.forEach(id => {
//   //   let v = "'" + selectionUtil.escSqlQuote(id) + "'";
//   //   let part = "("+idField.name+" = "+v+")";
//   //   if (where.length > 0) where += " OR ";
//   //   where += part;
//   //   values.push(v);
//   // });
//   // if (where.length > 0) {
//   //   where = "(" + idField.name + " IS NOT NULL) AND (" + where + ")";
//   // }
//   const url = Context.checkMixedContent(source.url);
//   const task = new lib.esri.QueryTask({url: url});
//   const query = new lib.esri.Query();
//   query.where = where;
//   queryUtil.applyGdbVersion(source,query);
//   return task.executeForIds(query);
// }

// function preparePeopleAssignments(task) {
//   const promise = new Promise((resolve,reject) => {
//
//     const peopleFeatureItems = task.peopleFeatureItems;
//     const peopleLayer = getPeopleSource().layer2D;
//     const peopleFields = peopleLayer.fields;
//     const unitsSource = getUnitsSource();
//     const unitsLayer = unitsSource.layer2D;
//     const unitFields = unitsLayer.fields;
//     const unitBasedFields = unitBasedFieldsForPeople;
//     const unitIds = [];
//     let relatedUnitInfo, utilizationStats, targetUnitId = null;
//
//     console.log("peopleFeatureItems",peopleFeatureItems)
//
//     let localUtilizationByUnitId = {};
//     let remoteUtilizationByUnitId;
//
//     let transactionInfo = {
//       peopleEdits: null,
//       unitEdits: null,
//       edits: null,
//       undo: {
//         peopleEdits: null,
//         unitEdits: null,
//         edits: null
//       }
//     }
//
//     peopleFeatureItems.forEach(featureItem => {
//       let unitId = aiimUtil.getAttributeValue(featureItem.feature.attributes,FieldNames.UNIT_ID);
//       if (typeof unitId === "string" && unitId.length > 0) {
//         if (unitIds.indexOf(unitId) === -1) unitIds.push(unitId);
//         if (localUtilizationByUnitId.hasOwnProperty(unitId)) {
//           let u = localUtilizationByUnitId[unitId];
//           localUtilizationByUnitId[unitId] = (u + 1);
//         } else {
//           localUtilizationByUnitId[unitId] = 1;
//         }
//       }
//     });
//
//     if (task.assignPeopleToUnit) {
//       const unitFeatureItem = task.assignPeopleToUnit.unitFeatureItem;
//       let unitId = aiimUtil.getAttributeValue(unitFeatureItem.feature.attributes,FieldNames.UNIT_ID);
//       if (typeof unitId === "string" && unitId.length > 0) {
//         targetUnitId = unitId;
//         if (unitIds.indexOf(unitId) === -1) unitIds.push(unitId);
//       }
//     }
//
//     const makePeopleEdits = () => {
//       const updates = [], undos = [];
//       peopleFeatureItems.forEach(featureItem => {
//         undos.push(clonePersonFeature(featureItem.feature,"ensure-geometry"));
//
//         const update = {attributes: {}};
//         update.attributes[peopleLayer.objectIdField] = featureItem.objectId;
//
//         if (task.assignPeopleToUnit) {
//           addAttributeEdit(peopleFields,update.attributes,FieldNames.PEOPLE_AREA_ID,null);
//           const unitFeatureItem = task.assignPeopleToUnit.unitFeatureItem;
//           const unitAttributes = unitFeatureItem.feature.attributes;
//           let unitGeometry = unitFeatureItem.geometry || unitFeatureItem.feature.geometry;
//           unitBasedFields.forEach(f => {
//             let v = aiimUtil.getAttributeValue(unitAttributes,f);
//             if (f === "unit_name") v = aiimUtil.getAttributeValue(unitAttributes,"name");
//             addAttributeEdit(peopleFields,update.attributes,f,v);
//           });
//           if (unitGeometry && typeof unitGeometry.clone !== "function") {
//             const g = Context.instance.lib.esri.Graphic.fromJSON({
//                attributes: unitAttributes,
//                geometry: unitGeometry
//             });
//             unitGeometry = g.geometry;
//           }
//           update.geometry = unitGeometry.clone().centroid;
//         }
//
//         if (task.assignPeopleToArea) {
//           appendPersonUnassignment(task,peopleFields,update);
//           const areaItem = task.assignPeopleToArea.areaItem;
//           const areaId = aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_ID);
//           addAttributeEdit(peopleFields,update.attributes,FieldNames.PEOPLE_AREA_ID,areaId);
//         }
//
//         if (task.unassignPeople) {
//           appendPersonUnassignment(task,peopleFields,update);
//         }
//
//         updates.push(update);
//       });
//
//       if (updates.length > 0) {
//         transactionInfo.peopleEdits = {updates: updates};
//         transactionInfo.undo.peopleEdits = {updates: undos};
//       }
//     };
//
//     const makeUnitEdits = () => {
//       const updates = [], undos = [];
//
//       const unitFeatures = (relatedUnitInfo && relatedUnitInfo.features) || [];
//       unitFeatures.forEach(feature => {
//         undos.push(cloneUnitFeature(feature,"no-geometry"));
//       });
//
//       const unitObjectIds = (relatedUnitInfo && relatedUnitInfo.objectIds) || [];
//       unitObjectIds.forEach(unitObjectId => {
//         let unitId = relatedUnitInfo.unitIdsByObjectId[unitObjectId];
//
//         let utilization = 0;
//         let localUtilization = 0;
//         let remoteUtilization = 0;
//         if (localUtilizationByUnitId.hasOwnProperty(unitId)) {
//           localUtilization = localUtilizationByUnitId[unitId];
//         }
//         if (remoteUtilizationByUnitId.hasOwnProperty(unitId)) {
//           remoteUtilization = remoteUtilizationByUnitId[unitId] - localUtilization;
//         }
//         if (task.assignPeopleToUnit) {
//           if (unitId === targetUnitId) {
//             utilization = remoteUtilization + peopleFeatureItems.length;
//           } else {
//             utilization = remoteUtilization;
//           }
//         }
//         if (task.assignPeopleToArea) {
//           utilization = remoteUtilization;
//         }
//         if (task.unassignPeople) {
//           utilization = remoteUtilization;
//         }
//         if (utilization < 0) utilization = 0;
//
//         let asnType = OfficePlan.SpaceAssignmentTypes.none
//         if (utilization > 0) {
//           asnType = OfficePlan.SpaceAssignmentTypes.office;
//         }
//
//         // TODO validate these?
//         const update = {attributes: {}};
//         update.attributes[unitsLayer.objectIdField] = unitObjectId;
//         addAttributeEdit(unitFields,update.attributes,
//           FieldNames.UNITS_AREA_ID,null);
//         addAttributeEdit(unitFields,update.attributes,
//           FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE,asnType);
//         addAttributeEdit(unitFields,update.attributes,
//           FieldNames.UTILIZATION, utilization);
//         updates.push(update);
//       });
//
//       if (updates.length > 0) {
//         transactionInfo.unitEdits = {updates: updates};
//         transactionInfo.undo.unitEdits = {updates: undos};
//       }
//     };
//
//     Promise.resolve().then(() => {
//       return fetchRelatedUnits(task,unitIds).then(result => {
//         relatedUnitInfo = result;
//         console.log("fetchRelatedUnits.relatedUnitInfo",relatedUnitInfo);
//       });
//     }).then(() => {
//       return calculateUtilization(unitIds).then(result => {
//         utilizationStats = result;
//         remoteUtilizationByUnitId = result.utilizationByUnitId;
//         console.log("calculateUtilization.utilizationStats",utilizationStats);
//         console.log("localUtilizationByUnitId",localUtilizationByUnitId)
//         console.log("remoteUtilizationByUnitId",remoteUtilizationByUnitId)
//       });
//     }).then(() => {
//       makePeopleEdits();
//       makeUnitEdits();
//     }).then(() => {
//       console.log("transactionInfo",transactionInfo)
//       task.transactionInfo = transactionInfo;
//       resolve(transactionInfo);
//     }).catch(ex => {
//       reject(ex);
//     });
//   });
//   return promise;
// }

// function updatePeopleAssignments(task) {
//   const promise = new Promise((resolve,reject) => {
//
//     preparePeopleAssignments(task).then(transactionInfo => {
//       if (transactionInfo.peopleEdits) {
//         const peopleLayer = getPeopleSource().layer2D;
//         const unitsLayer = getUnitsSource().layer2D;
//         const edits = [], undoEdits = [];
//         edits.push({
//           id: peopleLayer.layerId,
//           updates: transactionInfo.peopleEdits.updates
//         });
//         undoEdits.push({
//           id: peopleLayer.layerId,
//           updates: transactionInfo.undo.peopleEdits.updates
//         });
//         if (transactionInfo.unitEdits) {
//           edits.push({
//             id: unitsLayer.layerId,
//             updates: transactionInfo.unitEdits.updates
//           });
//           undoEdits.push({
//             id: unitsLayer.layerId,
//             updates: transactionInfo.undo.unitEdits.updates
//           });
//         }
//
//         const undoManager = OfficePlan.getActive().undoManager;
//         const undoTransaction = undoManager.makeTransaction({
//           hadPeopleEdits: !!transactionInfo.peopleEdits,
//           hadUnitEdits: !!transactionInfo.unitEdits,
//           requestInfo: makeApplyEditsRequestInfo(undoEdits)
//         });
//         undoTransaction.redoTransaction = undoManager.makeTransaction({
//           hadPeopleEdits: !!transactionInfo.peopleEdits,
//           hadUnitEdits: !!transactionInfo.unitEdits,
//           requestInfo: makeApplyEditsRequestInfo(edits)
//         });
//         console.log("undoTransaction",undoTransaction);
//
//         undoManager.addTransaction(undoTransaction);
//
//         const reqInfo = makeApplyEditsRequestInfo(edits);
//         const reqUrl = reqInfo.requestUrl;
//         const reqOpts = reqInfo.requestOptions;
//         const esriRequest = Context.instance.lib.esri.esriRequest;
//         console.log("applyEdits.reqInfo",reqInfo)
//
//         return esriRequest(reqUrl,reqOpts).then(result => {
//           console.log("updatePeopleAssignments.applyEdits.result",result);
//           // TODO check result for errors?
//           // result.data is an array of {id: layerId, updateResults: []}
//           if (transactionInfo.peopleEdits) peopleLayer.refresh();
//           if (transactionInfo.unitEdits) unitsLayer.refresh();
//         });
//
//       }
//     }).then(() => {
//     }).then(() => {
//       console.log("updatePeopleAssignments.resolving..........................")
//       resolve();
//     }).catch(ex => {
//       console.error("Error applying edits",ex);
//       reject(ex);
//     });
//
//   });
//   return promise;
// }

// function prepareUnitAssignments(task) {
//   const promise = new Promise((resolve,reject) => {
//
//     const transactionInfo = makeTransactionInfo();
//     const unitFeatureItems = task.unitFeatureItems;
//     const unitIds = [];
//     let relatedPeopleInfo;
//
//     unitFeatureItems.forEach(featureItem => {
//       const unitId = aiimUtil.getAttributeValue(featureItem.feature.attributes,FieldNames.UNIT_ID);
//       if (typeof unitId === "string" && unitId.length > 0) {
//         unitIds.push(unitId);
//       }
//     });
//
//     const makeUnitEdits = () => {
//       const updates = [], undos = [];
//       const layer = getUnitsSource().layer2D;
//       const fields = layer.fields;
//       //const keyField = layer.globalIdField;
//       const keyField = layer.objectIdField;
//
//       unitFeatureItems.forEach(featureItem => {
//         undos.push(cloneUnitFeature(featureItem.feature,"no-geometry"));
//
//         const update = {attributes: {}};
//         update.attributes[keyField] = featureItem.feature.attributes[keyField];
//
//         if (task.assignUnitsToArea) {
//           const areaItem = task.assignUnitsToArea.areaItem;
//           const areaType = task.assignUnitsToArea.areaType;
//           const areaId = aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_ID);
//           addAttributeEdit(fields,update.attributes,FieldNames.UNITS_AREA_ID,areaId);
//           addAttributeEdit(fields,update.attributes,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE,areaType);
//           addAttributeEdit(fields,update.attributes,FieldNames.UTILIZATION, 0)
//         }
//
//         if (task.unassignUnits) {
//           appendUnitUnassignment(task,fields,update);
//         }
//
//         updates.push(update);
//       });
//
//       if (updates.length > 0) {
//         transactionInfo.unitEdits = {updates: updates};
//         transactionInfo.undo.unitEdits = {updates: undos};
//         transactionInfo.edits.push({
//           id: layer.layerId,
//           updates: updates
//         });
//         transactionInfo.undo.edits.push({
//           id: layer.layerId,
//           updates: undos
//         });
//       }
//     };
//
//     const makePeopleEdits = () => {
//       let updates = [], undos = [];
//       const layer = getPeopleSource().layer2D;
//       //const keyField = layer.globalIdField;
//       const keyField = layer.objectIdField;
//
//       const keys = (relatedPeopleInfo && relatedPeopleInfo.objectIds);
//       const features = (relatedPeopleInfo && relatedPeopleInfo.features) || [];
//
//       if (task.assignUnitsToArea || task.unassignUnits) {
//         updates = makeUnassignPeopleUpdates(task,keys,keyField);
//       }
//       if (updates.length > 0) {
//         features.forEach(feature => {
//           undos.push(clonePersonFeature(feature,"ensure-geometry"));
//         });
//       }
//
//       if (updates.length > 0) {
//         transactionInfo.peopleEdits = {updates: updates};
//         transactionInfo.undo.peopleEdits = {updates: undos};
//         transactionInfo.edits.push({
//           id: layer.layerId,
//           updates: updates
//         });
//         transactionInfo.undo.edits.push({
//           id: layer.layerId,
//           updates: undos
//         });
//       }
//     };
//
//     Promise.resolve().then(() => {
//       return fetchRelatedPeople(task,unitIds).then(result => {
//         relatedPeopleInfo = result;
//         console.log("fetchRelatedPeople.relatedPeopleInfo",relatedPeopleInfo);
//       });
//     }).then(() => {
//       makeUnitEdits();
//       makePeopleEdits();
//     }).then(() => {
//       console.log("prepareUnitAssignments.transactionInfo",transactionInfo)
//       task.transactionInfo = transactionInfo;
//       resolve(transactionInfo);
//     }).catch(ex => {
//       reject(ex);
//     });
//
//   });
//   return promise;
// }

// function updateUnitAssignments(task) {
//   const promise = new Promise((resolve,reject) => {
//
//     prepareUnitAssignments(task).then(transactionInfo => {
//       const edits = transactionInfo.edits;
//       if (edits && edits.length > 0) {
//         const peopleLayer = getPeopleSource().layer2D;
//         const unitsLayer = getUnitsSource().layer2D;
//
//         const undoManager = OfficePlan.getActive().undoManager;
//         const undoTransaction = makeUndoTransaction(transactionInfo);
//         undoManager.addTransaction(undoTransaction);
//
//         const reqInfo = makeApplyEditsRequestInfo(edits);
//
//         const reqUrl = reqInfo.requestUrl;
//         const reqOpts = reqInfo.requestOptions;
//         const esriRequest = Context.instance.lib.esri.esriRequest;
//         console.log("applyEdits.reqInfo",reqInfo)
//
//         return esriRequest(reqUrl,reqOpts).then(result => {
//           console.log("updateUnitAssignments.applyEdits.result",result);
//           // TODO check result for errors?
//           // result.data is an array of {id: layerId, updateResults: []}
//           if (transactionInfo.peopleEdits) peopleLayer.refresh();
//           if (transactionInfo.unitEdits) unitsLayer.refresh();
//         });
//
//       }
//     }).then(() => {
//     }).then(() => {
//       console.log("updateUnitAssignments.resolving..........................")
//       resolve();
//     }).catch(ex => {
//       console.error("Error applying edits",ex);
//       reject(ex);
//     });
//
//   });
//   return promise;
// }

// function prepareAreaTransaction(task) {
//   const promise = new Promise((resolve,reject) => {
//
//     const transactionInfo = makeTransactionInfo();
//
//     const areaItem = task.areaItem;
//     const areaType = task.areaType;
//     const areaId = areaItem && aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_ID);
//     const areaIds = [areaId];
//     const areasTable = OfficePlan.getActive().areasTable;
//     const peopleSource = getPeopleSource();
//     const unitsSource = getUnitsSource();
//
//     const makePeopleEdits = (keys) => {
//       let updates = [], undos = [];
//       const layer = peopleSource.layer2D;
//
//       if (Array.isArray(keys)) {
//         const fields = layer.fields;
//         const keyField = layer.globalIdField;
//         //const keyField = layer.objectIdField;
//         keys.forEach(key => {
//           const update = {attributes: {}};
//           update.attributes[keyField] = key;
//           addAttributeEdit(fields,update.attributes,FieldNames.PEOPLE_AREA_ID,null);
//           updates.push(update);
//           const undo = {attributes: {}};
//           undo.attributes[keyField] = key;
//           addAttributeEdit(fields,undo.attributes,FieldNames.PEOPLE_AREA_ID,areaId);
//           undos.push(undo);
//         });
//       }
//
//       if (updates.length > 0) {
//         transactionInfo.peopleEdits = {updates: updates};
//         transactionInfo.undo.peopleEdits = {updates: undos};
//         transactionInfo.edits.push({
//           id: layer.layerId,
//           updates: updates
//         });
//         transactionInfo.undo.edits.push({
//           id: layer.layerId,
//           updates: undos
//         });
//       }
//     };
//
//     const makeUnitEdits = (keys) => {
//       const updates = [], undos = [];
//       const layer = unitsSource.layer2D;
//
//       if (Array.isArray(keys)) {
//         const fields = layer.fields;
//         const keyField = layer.globalIdField;
//         //const keyField = layer.objectIdField;
//         const none = OfficePlan.SpaceAssignmentTypes.none;
//         keys.forEach(key => {
//           const update = {attributes: {}};
//           update.attributes[keyField] = key;
//           addAttributeEdit(fields,update.attributes,FieldNames.UNITS_AREA_ID,null);
//           addAttributeEdit(fields,update.attributes,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE,none);
//           addAttributeEdit(fields,update.attributes,FieldNames.UTILIZATION,0);
//           updates.push(update);
//           const undo = {attributes: {}};
//           undo.attributes[keyField] = key;
//           addAttributeEdit(fields,undo.attributes,FieldNames.UNITS_AREA_ID,areaId);
//           addAttributeEdit(fields,undo.attributes,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE,areaType);
//           addAttributeEdit(fields,undo.attributes,FieldNames.UTILIZATION,0);
//           undos.push(undo);
//         });
//       }
//
//       if (updates.length > 0) {
//         transactionInfo.unitEdits = {updates: updates};
//         transactionInfo.undo.unitEdits = {updates: undos};
//         transactionInfo.edits.push({
//           id: layer.layerId,
//           updates: updates
//         });
//         transactionInfo.undo.edits.push({
//           id: layer.layerId,
//           updates: undos
//         });
//       }
//     };
//
//     const makeAreasTableEdits = () => {
//       const table = areasTable.table;
//       const fields = table.fields;
//       const keyField = table.globalIdField;
//       //const keyField = table.objectIdField;
//
//       if (task.addArea) {
//         const edit = {attributes: {}};
//         addAttributeEdit(fields,edit.attributes,FieldNames.AREA_ID,task.areaId);
//         addAttributeEdit(fields,edit.attributes,FieldNames.AREA_NAME,task.areaName);
//         addAttributeEdit(fields,edit.attributes,FieldNames.AREA_TYPE,task.areaType);
//
//         transactionInfo.areasTableEdits = {adds: [edit]};
//         transactionInfo.undo.areasTableEdits = {deletes: ["?"]};
//         transactionInfo.edits.push({
//           id: table.layerId,
//           adds: [edit]
//         });
//         transactionInfo.useGlobalIds = false;
//         transactionInfo.undo.edits.push({
//           id: table.layerId,
//           deletes: ["?"] // needs to be populated following add
//         });
//       }
//
//       if (task.deleteArea) {
//         const key = areaItem.attributes[keyField];;
//         const undo = {attributes: Object.assign({},areaItem.attributes)};
//
//         transactionInfo.areasTableEdits = {deletes: [key]}
//         transactionInfo.undo.areasTableEdits = {adds: [undo]};
//         transactionInfo.edits.push({
//           id: table.layerId,
//           deletes: [key]
//         });
//         transactionInfo.undo.edits.push({
//           id: table.layerId,
//           adds: [undo]
//         });
//       }
//
//       if (task.renameArea) {
//         const name = task.areaName;
//         const prevName = aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_NAME);
//         const key = areaItem.attributes[keyField];
//         const update = {attributes: {}};
//         update.attributes[keyField] = key;
//         addAttributeEdit(fields,update.attributes,FieldNames.AREA_NAME,name);
//         const undo = {attributes: {}};
//         undo.attributes[keyField] = key;
//         addAttributeEdit(fields,undo.attributes,FieldNames.AREA_NAME,prevName);
//
//         transactionInfo.areasTableEdits = {updates: [update]}
//         transactionInfo.undo.areasTableEdits = {updates: [undo]}
//         transactionInfo.edits.push({
//           id: table.layerId,
//           updates: [update]
//         });
//         transactionInfo.undo.edits.push({
//           id: table.layerId,
//           updates: [undo]
//         });
//       }
//     };
//
//     Promise.resolve().then(() => {
//       if (task.unassignArea) {
//         return queryGlobalIndex(peopleSource,areaIds,areaType).then(result => {
//           console.log("people.queryGlobalIndex",result)
//           makePeopleEdits(Object.keys(result.globalIdIndex));
//           //makePeopleEdits(peopleObjectIds);
//         });
//         // return queryObjectIds(peopleSource,areaIds,areaType).then(peopleObjectIds => {
//         //   makePeopleEdits(peopleObjectIds);
//         // });
//       }
//     }).then(() => {
//       if (task.unassignArea) {
//         return queryGlobalIndex(unitsSource,areaIds,areaType).then(result => {
//           console.log("units.queryGlobalIndex",result)
//           makeUnitEdits(Object.keys(result.globalIdIndex));
//         });
//         // return queryObjectIds(unitsSource,areaIds,areaType).then(unitObjectIds => {
//         //   //makeUnitEdits(unitObjectIds);
//         // });
//       }
//     }).then(() => {
//       makeAreasTableEdits();
//     }).then(() => {
//       console.log("prepareAreaUnassignments.transactionInfo",transactionInfo)
//       task.transactionInfo = transactionInfo;
//       resolve(transactionInfo);
//     }).catch(ex => {
//       reject(ex);
//     });
//
//   });
//   return promise;
// }

// function updateArea(task) {
//   const promise = new Promise((resolve,reject) => {
//
//     prepareAreaTransaction(task).then(transactionInfo => {
//       const edits = transactionInfo.edits;
//       if (edits && edits.length > 0) {
//         const peopleLayer = getPeopleSource().layer2D;
//         const unitsLayer = getUnitsSource().layer2D;
//         const areasTable = OfficePlan.getActive().areasTable;
//
//         const undoManager = OfficePlan.getActive().undoManager;
//         const undoTransaction = makeUndoTransaction(transactionInfo);
//         undoManager.addTransaction(undoTransaction);
//
//         const reqInfo = makeApplyEditsRequestInfo(edits,transactionInfo);
//         const reqUrl = reqInfo.requestUrl;
//         const reqOpts = reqInfo.requestOptions;
//         const esriRequest = Context.instance.lib.esri.esriRequest;
//         console.log("applyEdits.reqInfo",reqInfo)
//
//         return esriRequest(reqUrl,reqOpts).then(result => {
//           console.log("updateArea.applyEdits.result",result);
//           // TODO check result for errors?
//           // result.data is an array of {id: layerId, updateResults: []}
//
//           if (task.addArea) {
//             const areasLayerId = areasTable.table.layerId;
//             const results = (result && result.data)
//             if (Array.isArray(results)) {
//               results.forEach(layerResult => {
//                 if (layerResult.id === areasLayerId) {
//                   if (layerResult.addResults && layerResult.addResults.length === 1) {
//                     const newKey = layerResult.addResults[0].globalId;
//                     console.log("*************** newKey",newKey)
//                     transactionInfo.undo.areasTableEdits = {deletes: [newKey]};
//                     transactionInfo.undo.edits[0].deletes = [newKey];
//                     undoTransaction.requestInfo = makeApplyEditsRequestInfo(
//                       transactionInfo.undo.edits,transactionInfo.undo)
//                     console.log("newTransactionInfo",transactionInfo)
//                   }
//                 }
//               });
//             }
//           }
//
//           if (transactionInfo.peopleEdits) peopleLayer.refresh();
//           if (transactionInfo.unitEdits) unitsLayer.refresh();
//           //if (transactionInfo.areasTableEdits) areasTable.refresh();
//         });
//
//       }
//     }).then(() => {
//     }).then(() => {
//       console.log("updateArea.resolving..........................")
//       resolve();
//     }).catch(ex => {
//       console.error("Error applying edits",ex);
//       reject(ex);
//     });
//
//   });
//   return promise;
// }

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
